<template>
  <div>
    <ith-grid-skeleton v-show="items == null" :items="14" />
    <div v-show="items == ''">
      <ith-no-results :text="no_result" />
    </div>

    <div :class="{ movieArea: banner.length != 0 }">
      <div class="movie">
        <div
          v-for="item in items"
          :key="item.id"
          class="movie--item"
          @click="goToShow(item)"
        >
          <router-link :to="`/detail/${item.id}`">
            <figure class="movie-img">
              <div v-lazy-container="{ selector: 'img' }">
                <img
                  v-if="item.imageUrl != null"
                  class="movie-img"
                  :data-src="item.imageUrl"
                />
                <img v-else class="movie-no-img" data-src="/img/no_image.png" />
              </div>
            </figure>
            <span class="movie-overlay">
              <p><font-awesome-icon color="#ffffff" icon="plus" /> Details</p>
              <p>
                <font-awesome-icon color="#ffffff" icon="heart" />
                {{ item.likes | likes }}
              </p>
              <p>
                <img
                  class="icon--imdb"
                  src="../../assets/imdb.png"
                  alt="IMBD logo"
                />
                {{ item.imdbRating }}
              </p>
              <p>
                <span v-show="item.watchlist"
                  ><font-awesome-icon color="#ffffff" icon="check" /> Watchlist
                </span>
                <span v-show="!item.watchlist" style="color: #939292"
                  ><font-awesome-icon icon="plus-circle" /> Watchlist</span
                >
              </p>
              <p>
                <span v-show="item.watched"
                  ><font-awesome-icon color="#ffffff" icon="eye" /> Watched
                </span>
                <span v-show="!item.watched" style="color: #939292"
                  ><font-awesome-icon icon="eye" /> Watched</span
                >
              </p>
              <span
                class="platform"
                v-if="item.platforms && item.platforms.length"
                >{{ item.platforms[0].platform | uppercase }}</span
              >
            </span>
          </router-link>
        </div>
      </div>
      <div class="sad-asside" style="margin: 0px 30px" v-if="banner != []">
        <ith-sad-asside :items="banner" />
      </div>
    </div>
    <ith-pagination-bullets
      :items="pages"
      :pagination="page"
      :k="items_user.visibility"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    params: { page: 0, wShows: "", country: "USA" },
    items: null,
    pages: 0,
    page: 0,
    banner: [],
    watchlistLocal: [],
    watchedLocal: [],
    watched: [],
    watchlist: [],
    paramsShow: {
      showId: "",
      country: "USA",
    },
    totalPagesWatched: 0,
    totalPagesWatchlist: 0,
    no_result: `<p>You don't have any movie or</p>
                </p>series in your watchlist list yet</p>`,
    no_result_watchlist: `<p>You don't have any movie or</p>
                          </p>series in your watchlist list yet</p>`,
    no_result_watched: `<p>You don't have any movie or</p>
                          </p>series in your watched list yet</p>`,
  }),
  computed: mapState([
    "user",
    "items_user",
    "pageWatchlist",
    "pageWatched",
    "banners",
  ]),

  mounted() {
    this.getWatchlist();
  },
  created() {
    this.getBanner();
  },

  watch: {
    user() {
      this.pages = 0;
      this.page = 0;
      this.totalPagesWatched = 0;
      this.totalPagesWatchlist = 0;
      this.$store.commit("EDIT_PAGINATION_WATCHLIST", this.page);
      this.$store.commit("EDIT_PAGINATION_WATCHED", this.page);
      this.watched = [];
      this.watchlist = [];
      this.getWatchlist();
    },
    pageWatchlist() {
      this.items = null;
      this.fetchWatchlist();
    },
    pageWatched() {
      this.items = null;
      this.fetchWatched();
    },
    banners() {
      if (this.banners) this.getBanner();
    },

    "items_user.visibility": function () {
      if (this.items_user.visibility == "Watchlist") {
        this.no_result = this.no_result_watchlist;
        this.items = this.watchlist;
        this.pages = this.totalPagesWatchlist;
        this.page = this.pageWatchlist;
      } else {
        this.no_result = this.no_result_watched;
        this.items = this.watched;
        this.pages = this.totalPagesWatched;
        this.page = this.pageWatched;
      }
    },
  },

  methods: {
    getBanner() {
      if (this.banners)
        this.banners.forEach((el) => {
          if (el.page == "watchlist" && el.position == "right")
            this.banner.push(el);
        });
      this.banner.sort(function (a, b) {
        if (a.order < b.order) {
          return -1;
        }
        if (a.order > b.order) {
          return 1;
        }
        return 0;
      });
    },

    getWatchlist() {
      this.watchlist = [];
      this.items = [];
      if (this.user == null || !this.user.username) {
        this.watchlistLocal = JSON.parse(
          localStorage.getItem("OTT/Watchlist/Guest")
        );
        if (this.watchlistLocal != null) {
          let wshow = [];
          for (let index = 0; index < this.watchlistLocal.length; index++) {
            wshow.push(this.watchlistLocal[index].showId);
          }
          this.params.wlShows = wshow.toString();
          this.$Parse.Cloud.run("getWatchlist", this.params).then((res) => {
            this.watchlist = res.items;
            if (this.items_user.visibility == "Watchlist")
              this.items = res.items;
            this.pages = 0;
            this.page = 0;
          });

          this.$store.commit(
            "EDIT_ITEMS_WATCHLIST_SHOWS",
            this.watchlistLocal.length
          );
        } else {
          this.$store.commit("EDIT_ITEMS_WATCHLIST_SHOWS", 0);
        }

        this.watchedLocal = JSON.parse(
          localStorage.getItem("OTT/Watched/Guest")
        );
        if (this.watchedLocal != null) {
          let wshow = [];
          for (let index = 0; index < this.watchedLocal.length; index++) {
            wshow.push(this.watchedLocal[index].showId);
          }
          this.params.wlShows = wshow.toString();
          this.$Parse.Cloud.run("getWatchlist", this.params).then((res) => {
            this.watched = res.items;
            if (this.items_user.visibility == "Watched") this.items = res.items;
            this.pages = 0;
            this.page = 0;
          });
          this.$store.commit(
            "EDIT_ITEMS_WATCHED_SHOWS",
            this.watchedLocal.length
          );
        } else {
          this.$store.commit("EDIT_ITEMS_WATCHED_SHOWS", 0);
        }
      } else {
        this.items = null;
        this.fetchWatchlist();
        this.fetchWatched();
      }
    },
    fetchWatchlist() {
      this.params.page = this.pageWatchlist;
      this.$Parse.Cloud.run("getWatchlist", this.params).then((result) => {
        this.watchlist = result.items;
        this.$store.commit("EDIT_PAGINATION_WATCHLIST", result.page);
        this.$store.commit("EDIT_ITEMS_WATCHLIST_SHOWS", result.count);
        this.totalPagesWatchlist = result.totalPages;
        if (this.items_user.visibility == "Watchlist") {
          this.items = result.items;
          this.pages = result.totalPages;
          this.page = result.page;
        }
      });
    },
    fetchWatched() {
      this.params.page = this.pageWatched;
      this.$Parse.Cloud.run("getWatchedShows", this.params).then((result) => {
        this.watched = result.items;
        this.$store.commit("EDIT_PAGINATION_WATCHED", result.page);
        this.$store.commit("EDIT_ITEMS_WATCHED_SHOWS", result.count);
        this.totalPagesWatched = result.totalPages;
        if (this.items_user.visibility == "Watched") {
          this.items = result.items;
          this.pages = result.totalPages;
          this.page = result.page;
        }
      });
    },
    goToShow(item) {
      this.$store.commit("EDIT_SHOW", item);
      // this.$router.push(`/detail/${item.id}`);
    },
  },
};
</script>

<style scoped>
.movie {
  display: grid;
  grid-template-columns: repeat(7, auto);
  justify-content: space-evenly;
  column-gap: 15px;
}
.width-70 {
  width: 70%;
}
.movie--item {
  margin-top: 20px;
  width: 130px;
  height: 187px;
  background-color: #d5d5d5;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  display: block;
}

.movie-img {
  margin: 0;
  border-radius: 10px;
  background-color: #d5d5d5;
  width: 130px;
  height: 187px;
  object-fit: cover;
}
.movie-overlay {
  font-size: 0.75rem;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: none;
  border: 3px solid #ff5f5f;
  align-items: center;
  justify-content: center;
  color: white;
}

.movie-no-img {
  margin: 0;
  border-radius: 10px;
  width: 70%;
  object-fit: contain;
  margin: 20% 15%;
}

.movie-overlay > p {
  margin-top: 2px;
  text-align: center;
}

.movie--item:hover .movie-overlay {
  display: flex;
  flex-direction: column;
}
.platform {
  border-radius: 0px 0px 7px 7px;
  position: absolute;
  width: 100%;
  padding: 2px 2px 3px 2px;
  bottom: 0px;
  border: 1px solid #ff5f5f;
  background: #ff5f5f;
  text-align: center;
}
.icon--imdb {
  width: 27px;
}
.movieArea {
  width: 100%;
  display: flex;
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .movie {
    grid-template-columns: repeat(5, auto);
    justify-content: space-evenly;
    column-gap: 42px;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .movie {
    grid-template-columns: repeat(4, auto);
    justify-content: space-evenly;
    column-gap: 42px;
  }
}
@media (min-width: 600px) and (max-width: 1020px) {
  .movie {
    grid-template-columns: repeat(4, auto);
    justify-content: space-evenly;
  }
  .movieArea {
    display: block;
  }
}

@media (max-width: 600px) {
  .movie {
    grid-template-columns: repeat(2, auto);
    justify-content: space-evenly;
    column-gap: 15px;
  }
  .movieArea {
    display: block;
  }
}
</style>
